var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bqGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E4C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2C6B82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bqAccent",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCD517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D97D2B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodOpacity: 0.15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 20)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,65 C25,55 10,60 5,63 L5,23 C10,20 25,15 40,25 Z",
    fill: "url(#bqGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,65 C55,55 70,60 75,63 L75,23 C70,20 55,15 40,25 Z",
    fill: "#255E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,25 L40,65",
    stroke: "url(#bqAccent)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 28,
    fontFamily: "'Outfit', 'Inter', sans-serif",
    fontWeight: 900,
    fontSize: 34,
    fill: "url(#bqAccent)",
    textAnchor: "middle"
  }, "?"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 68)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Outfit', 'Inter', system-ui, sans-serif",
    fontWeight: 800,
    fontSize: 36,
    fill: "#1E4C5C",
    letterSpacing: -0.5
  }, "\n      Bibli", /*#__PURE__*/React.createElement("tspan", {
    fill: "#D97D2B"
  }, "Quien?")), /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 20,
    fontFamily: "'Inter', system-ui, sans-serif",
    fontWeight: 600,
    fontSize: 11,
    fill: "#666666",
    letterSpacing: 1.5
  }, "\n      TRIVIA B\xCDBLICA\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e5ec1e85ca6147b93355be430496e443.svg";
export { ForwardRef as ReactComponent };